import {ReactElement} from "react"

const CaptainIcon = ():ReactElement => {
	return (
    <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.73314 10.8581C1.83145 10.2455 0.208408 7.64189 0.929761 5.80405C1.83145 3.50676 7.69232 0.75 11.7499 0.75C15.8075 0.75 21.6685 3.50676 22.5702 5.80405C23.2916 7.64189 21.6685 10.2455 20.7669 10.8581M2.73314 10.8581H20.7669M2.73314 10.8581V13.1554M20.7669 10.8581V13.1554M2.73314 13.1554H20.7669M2.73314 13.1554C3.33423 14.6869 5.97911 17.75 11.7499 17.75C17.5208 17.75 20.1657 14.6869 20.7669 13.1554M11.7499 4.88514C11.4494 4.88514 10.8482 4.70135 10.8482 3.96622C10.8482 3.23108 11.4494 3.0473 11.7499 3.0473C12.0505 3.0473 12.6516 3.23108 12.6516 3.96622C12.6516 4.70135 12.0505 4.88514 11.7499 4.88514ZM11.7499 4.88514V8.56081M11.7499 8.56081C10.8482 8.56081 9.49571 7.9482 9.04486 7.64189M11.7499 8.56081C12.6516 8.56081 13.373 8.37703 14.455 7.64189M10.8482 6.26351H12.6516"
        stroke="#374151"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CaptainIcon
